import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ampli } from '../../../ampli';
import { MainHead } from '../../../components/common/head/MainHead';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useLayout } from '../../../hooks/screen/useLayout';
import { OpenMarketProductSummaryView } from '../../../views/Product/detailView/OpenMarketProductSummaryView/OpenMarketProductSummaryView';
import { OpenMarketDetailPageFooter } from './components/OpenMarketDetailPageFooter';
import { OpenMarketRequestConsultButton } from './components/OpenMarketRequestConsultButton';
import { useGetOpenMarketProductByIdQuery } from '../../../hooks/api/product/queries/useGetOpenMarketProductById.query';
import { usePatchOpenMarketProductViewsByIdMutation } from '../../../hooks/api/product/mutations/usePatchOpenMarketProductViewsById.mutation';
import { getOpenMarketProductTitle } from '../../../utils/getter/getOpenMarketProductTitle.util';

export const OpenMarketDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { productId } = useParams();
  const [isAmpliEventCalled, setIsAmpliEventCalled] = useState<boolean>(false);

  const { data: product, isLoading: isGetProductQueryLoading } = useGetOpenMarketProductByIdQuery({
    productId: productId!,
  });

  const { mutate: patchOpenMarketProductById } = usePatchOpenMarketProductViewsByIdMutation();

  useEffect(() => {
    if (product) {
      if (product.status !== 'ONSALE') {
        navigate('/open-market/list');
      }
    }
  }, [product, navigate, location.pathname]);

  useEffect(() => {
    if (product && productId && !isAmpliEventCalled) {
      patchOpenMarketProductById({ productId, reqBody: { views: product.views + 1 } });

      ampli.마켓오픈마켓매물상세페이지조회({
        '게시글 제목': getOpenMarketProductTitle(product),
        '매물 코드': product.code,
      });

      setIsAmpliEventCalled(true);
    }
  }, [product, productId, patchOpenMarketProductById, isAmpliEventCalled]);

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true, directlyPassedURL: pageInfo.openMarketListPage.path }} />,
    fixedFooter: (
      <OpenMarketDetailPageFooter>
        <OpenMarketRequestConsultButton product={product!} />
      </OpenMarketDetailPageFooter>
    ),
    fixedHeaderHeight: 40,
    fixedFooterHeight: 0,
  });

  if (isGetProductQueryLoading) return <AnimateLoading />;

  if (product) {
    return (
      <>
        <Helmet>
          <title>{`${getOpenMarketProductTitle(product)} - Pluva Market`}</title>
        </Helmet>

        <OpenMarketProductSummaryView product={product} />
      </>
    );
  }

  return <></>;
};
